import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as ReportModule from 'Modules/ReportModule';
import i18next from 'i18next';
import ReactTable from "react-table";
import {Cell} from "HelperFunctions/Lists";

type P = {
    //
};
type S = {
    //
};
type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
    t?: i18next.TFunction;
};

class TerminalInstallationReport extends React.Component<P & ConnectedP, S> {
    public render() {
        const {reportStore, t} = this.props;
        if (reportStore.activeTerminalsReport) {
            return (
                <>
                    <h3 className="main__title">{reportStore.activeTerminalsReport.reportTitle}</h3>

                    <ReactTable
                        className="pure-table"
                        data={reportStore.activeTerminalsReport.activeTerminals}
                        filterable={false}
                        sortable={false}
                        columns={this.renderColumns(t)}
                        pageSize={5}
                    />
                </>
            );
        } else {
            return null;
        }
    }

    private renderColumns = (t) => [
        {
            Header: Cell.HeaderTextCell(t('deviceId')),
            accessor: 'deviceId',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell('VIN'),
            accessor: 'vin',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('installationDate')),
            accessor: 'installationDate',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell('MSISDN'),
            accessor: 'msisdn',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('carModel')),
            accessor: 'carModel',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('months')),
            accessor: 'months',
            Cell: Cell.CutTextCell
        }
    ];
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

export default withTranslation('reports')(connect(mapStateToProps)(TerminalInstallationReport) as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/ReportsComposites/ActiveTerminalsReportView.tsx